<template>
  <div class="detail-comment-send">
    <!-- 文本输入 -->
    <div
      ref="textBox"
      class="comment-input"
      contenteditable="true"
      :placeholder="placeholder"
      :style="customStyle"
      @input="handleInput"
      @focus="handleFocus"
    ></div>
    <!-- 工具栏 -->
    <div class="tool-bar">
      <div class="left-wrapper">
        <!-- 图片上传 -->
        <div v-if="showImg" class="img-update-btn">
          <i class="wiki-icon wiki-editor-pic"></i><input accept="image/*" type="file" @change="uploadImg" />
        </div>
      </div>
      <div style="display: flex; align-items: center;">
        <el-button class="send-btn" type="primary" @click="_onOk">{{ sendBtnText }}</el-button>
        <el-button style="height: 24px; line-height: 24px; padding-top: 0; padding-bottom: 0;" @click="handleCancel"
          >取消</el-button
        >
      </div>
    </div>
    <!-- 图片、视频 -->
    <div v-if="resources.length" class="img-group">
      <div v-for="(item, index) in resources" :key="item.key" class="item">
        <div class="close-btn" @click="onCloseImg(index)">
          <i class="el-icon-close"></i>
        </div>
        <div v-if="item.percent > 0 && item.percent < 100" class="percent-box">{{ item.percent }}%</div>
        <img v-if="item.url" :src="item.url" alt="" />
        <img v-else src="@/assets/images/local.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { uploadFile } from "@/plugins/uploadFile";

export default {
  props: {
    // 编辑框占位文案
    placeholder: {
      type: String,
      default: "说点什么吧"
    },
    customStyle: {
      type: Object,
      default: () => ({})
    },
    // 确认按钮文案
    sendBtnText: {
      type: String,
      default: "发 布"
    },
    // 是否显示上传视频按钮
    showVideo: {
      type: Boolean,
      default: true
    },
    // 是否显示上传视频按钮
    showImg: {
      type: Boolean,
      default: true
    },
    isShowEdit: {
      type: Boolean,
      default: true
    },
    // 确定按钮回调
    onOk: {
      type: Function,
      default: null
    }
  },
  model: {},
  components: {},
  data() {
    return {
      resources: [],
      resizeObserver: null
    };
  },
  computed: {
    ...mapGetters(["gameInfo", "loginUser"])
  },
  watch: {},
  created() {},
  async mounted() {
    await this.$nextTick();
    this.$refs.textBox.focus();
  },
  updated() {},
  destroyed() {},
  methods: {
    uploadImg(e) {
      let file = e.target.files[0];
      let item = {
        file: file,
        percent: 0,
        type: "img",
        url: "",
        key: parseInt(Math.random() * 1000000)
      };
      this.resources.push(item);
      uploadFile({
        file,
        percent: 0,
        progressCb: percent => {
          item.percent = percent;
        }
      }).then(res => {
        item.percent = 100;
        item.url = res.url;
      });
    },
    onCloseImg(index) {
      this.resources.splice(index, 1);
    },

    _onOk() {
      let isUpdate = true;
      this.resources.forEach(item => {
        if (item.percent < 100) {
          isUpdate = false;
        }
      });
      if (!isUpdate) {
        this.$message("还有资源未上传完成");
        return;
      }
      const text = this.$refs.textBox.innerText || "";
      if (text.trim() == "") {
        this.$message("内容为空，请重新输入！");
        return;
      }
      const data = this.formatData();
      if (this.onOk) {
        this.onOk(data);
      }
    },
    onClear() {
      this.$refs.textBox.innerHTML = "";
      this.resources = [];
    },
    handleInput() {
      const text = this.$refs.textBox.innerText;
      if (text.length === 1 && !text.trim()) {
        this.$refs.textBox.innerHTML = "";
      }
    },
    handleFocus() {
      this.$emit("focus");
    },
    handleCancel() {
      this.$emit("cancel");
    },
    formatData() {
      const text = this.$refs.textBox.innerText || "";
      console.log(1 + text);
      let contentJson = [{ type: "paragraph", children: [{ text: text }] }];
      let thumb = [];
      this.resources.forEach(item => {
        if (item.type == "img") {
          // 一行一个
          const imgJson = {
            type: "paragraph",
            children: [
              { text: "" },
              {
                type: "image",
                key: Math.random()
                  .toString(8)
                  .slice(2),
                src: item.url,
                alt: "",
                isAdaptive: true,
                style: {},
                children: [{ text: "" }]
              },
              { text: "" }
            ]
          };
          contentJson.push(imgJson);
          if (thumb.length < 3) {
            thumb.push(item.url);
          }
        } else if (item.type == "video") {
          const videoJson = {
            type: "video",
            src: item.videoUrl,
            poster: item.url,
            children: [{ text: "" }]
          };
          contentJson.push(videoJson);
        }
      });

      return {
        text,
        resources: this.resources,
        contentJson,
        thumb
      };
    }
  }
};
</script>

<style lang="less" scoped>
.detail-comment-send {
  width: 100%;
  border-radius: 4px;
}
.comment-input {
  width: 100%;
  font-size: 14px;
  user-modify: read-write-plaintext-only;
  -webkit-user-modify: read-write-plaintext-only;
  overflow: auto;
  resize: none;
  border: none;
  background-color: #f2f2f2;
  border-radius: 4px;
  padding: 10px 12px;
  max-height: 200px;
  &:empty:before {
    content: attr(placeholder);
    color: #bbb;
    font-size: 13px;
  }
}

.tool-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  margin-top: 10px;
  .left-wrapper {
    display: flex;
    align-items: center;

    .img-update-btn {
      width: 30px;
      height: 30px;
      position: relative;
      background-size: 100% 100%;
      border-radius: 4px;
      font-size: 24px;
      display: flex;
      align-items: center;
      input {
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 10;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
  .send-btn {
    width: 52px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background: #00afe8;
    border-radius: 4px;
  }
}

.img-group {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  .item {
    width: 60px;
    height: 60px;
    margin: 10px 10px 0 0;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .close-btn {
      position: absolute;
      top: -6px;
      right: -6px;
      z-index: 10;
      background: #fff;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 0 3px #ddd;
      cursor: pointer;
      transition: 0.3s;

      &:hover {
        box-shadow: 0 0 6px #bbb;
      }
    }

    .percent-box {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 9;
      display: flex;
      align-items: center;
      justify-content: center;
      background: fade(#000, 20%);
      width: 100%;
      height: 100%;
      color: #333;
      font-size: 12px;
    }

    .el-icon-video-play {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 5;
      transform: translate(-50%, -50%);
      font-size: 30px;
      color: #fff;
      text-shadow: 0 0 4px #bbb;
    }
  }
}
</style>
